import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import Build from "@material-ui/icons/Build";
import Group from "@material-ui/icons/Group";
import Public from "@material-ui/icons/Public";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import productStyle from "assets/jss/material-kit-pro-react/views/landingPageSections/productStyle.jsx";

class SectionProduct extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title}>What we can do for you</h2>
            <h5 className={classes.description}>
              We provide an end to end solution for designing, building, launching, managing, and maintaining web and mobile apps.
              We maintain and support products that we have developed in order to allow our customers to focus on their core business.
            </h5>
          </GridItem>
        </GridContainer>
        <div>
          <h2 className={classes.title}>Process</h2>
          <GridContainer>
            <GridItem xs={12} sm={4} md={4}>
              <InfoArea
                title="Research and Design"
                description="We work with our customers to understand their requirements and perform research to ensure we are going to be building the right thing. Our designers will design an app that is both functional and looks great."
                icon={Group}
                iconColor="info"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <InfoArea
                title="Build and Iterate"
                description="Once a preliminary design is complete, we will begin building the product in order to have some working software available early in the process. This will allow us to get feedback and make iterations early rather than waiting until the end to make changes."
                icon={Build}
                iconColor="success"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <InfoArea
                title="Launch and Monitor"
                description="After we release a product, we will monitor bug reports and user feedback. We will make any necessary updates in order to solve any issues that were discovered through widespread use."
                icon={Public}
                iconColor="danger"
                vertical
              />
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(productStyle)(SectionProduct);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/SectionProduct.jsx